import React from 'react'
import { Texto, Horizontal } from '@gravitate-js/excalibrr'
import { ExclamationCircleFilled, UploadOutlined, WarningOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { Card } from 'antd'

export const UploadStatusCards = ({ statusResponse, statusView }) => {
  return (
    <Horizontal gap={16} className='flex justify-sb mb-3'>
      <StatusCard
        count={statusResponse.updated_count}
        status='success'
        label='Record(s) Uploaded'
        icon={
          <Texto appearance={statusResponse.updated_count === 0 ? 'hint' : 'success'} category='h3'>
            <UploadOutlined />
          </Texto>
        }
      />
      <StatusCard
        count={statusResponse.warning_count}
        status='warning'
        label='Record Warning(s)'
        icon={
          <Texto appearance={statusResponse.warning_count === 0 ? 'hint' : 'warning'} category='h3'>
            <WarningOutlined />
          </Texto>
        }
        statusView={statusView}
      />
      <StatusCard
        count={statusResponse.error_count}
        status='error'
        label='Record Error(s)'
        icon={
          <Texto appearance={statusResponse.error_count === 0 ? 'hint' : 'error'} category='h3'>
            <ExclamationCircleFilled />
          </Texto>
        }
        statusView={statusView}
      />
    </Horizontal>
  )
}
const StatusCard = ({ count, status, label, icon, statusView }) => {
  let disabled = ''
  if (count < 1) {
    disabled = 'disabled'
  }
  const borderColor =
    status === 'success' ? 'var(--theme-success)' : status === 'warning' ? 'var(--theme-warning)' : 'var(--theme-error)'
  return (
    <Card size='small' style={{ flex: 1, ...(count && { border: `1px solid ${borderColor}` }) }}>
      <div className='flex justify-sb p-1'>
        <Texto category='h3' weight='bold' appearance={disabled ? 'hint' : ''}>
          {count}
        </Texto>
        <div className='mt-1'>{icon}</div>
      </div>
      <div className='p-1'>
        <Texto weight='bold' appearance={disabled ? 'hint' : ''}>
          {label}
        </Texto>
      </div>
    </Card>
  )
}
